import memoizeOne from 'memoize-one';
import type { Item, ChildItem } from '../../../../model/table';
import { DEFAULT_LEVEL } from '../../common/constants';
import type { ListItem, ChartItem } from '../../common/types';

type TransformedItems = {
	listItems: ListItem[];
	chartItems: ChartItem[];
};

const DEFAULT_ITEMS = {
	listItems: [],
	chartItems: [],
} as const;

const DEFAULT_CHILD_ITEMS = {
	listChildItems: [],
	chartChildItems: [],
} as const;

const normaliseChildItems = (item: Item) => {
	const { childItems } = item;

	if (!childItems) {
		return DEFAULT_CHILD_ITEMS;
	}

	// @ts-expect-error - TS2315 - Type 'ChildItem' is not generic. | TS2304 - Cannot find name 'ListData'.
	const listChildItems: Array<ChildItem<ListData>> = [];
	// @ts-expect-error - TS2315 - Type 'ChildItem' is not generic. | TS2304 - Cannot find name 'ChartData'.
	const chartChildItems: Array<ChildItem<ChartData>> = [];

	childItems.forEach((childItem: ChildItem) => {
		const { id, level = DEFAULT_LEVEL - 1, listData, chartData } = childItem;

		listChildItems.push({
			id,
			level,
			...listData,
		});

		chartChildItems.push({
			id,
			level,
			...chartData,
		});
	});

	return { listChildItems, chartChildItems };
};

export default memoizeOne((items: Item[]): TransformedItems => {
	if (items.length === 0) {
		// @ts-expect-error - TS2322 - Type '{ readonly listItems: readonly []; readonly chartItems: readonly []; }' is not assignable to type 'TransformedItems'.
		return DEFAULT_ITEMS;
	}

	const listItems: Array<ListItem> = [];
	const chartItems: Array<ChartItem> = [];

	items.forEach((item: Item) => {
		const { id, listData, chartData, level = DEFAULT_LEVEL } = item;
		const { listChildItems, chartChildItems } = normaliseChildItems(item);

		listItems.push({
			id,
			level,
			// @ts-expect-error - TS2322 - Type 'any[] | readonly []' is not assignable to type 'ChildItem<ListData>[]'.
			childItems: listChildItems,
			...listData,
		});

		chartItems.push({
			id,
			level,
			// @ts-expect-error - TS2322 - Type 'any[] | readonly []' is not assignable to type 'ChildItem<ChartData>[]'.
			childItems: chartChildItems,
			...chartData,
		});
	});

	return { listItems, chartItems };
});
